import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "post-proofreading-instructions" }
const _hoisted_2 = { class: "instruction-step" }
const _hoisted_3 = { class: "step-title" }
const _hoisted_4 = { class: "step-intro" }
const _hoisted_5 = { class: "instruction-step" }
const _hoisted_6 = { class: "step-title" }
const _hoisted_7 = { class: "step-intro" }
const _hoisted_8 = { class: "warning-box" }
const _hoisted_9 = { class: "warning-label" }
const _hoisted_10 = { class: "instruction-step" }
const _hoisted_11 = { class: "step-title" }
const _hoisted_12 = { class: "step-intro" }
const _hoisted_13 = { class: "instruction-step" }
const _hoisted_14 = { class: "step-title" }
const _hoisted_15 = { class: "step-intro" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('proofreadingInstructions.postProofreadingUnlockTitle')), 1),
      _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('proofreadingInstructions.postProofreadingUnlockIntro')), 1),
      _createElementVNode("ol", null, [
        _createElementVNode("li", null, _toDisplayString(_ctx.$t('proofreadingInstructions.postProofreadingUnlockStep1')), 1),
        _createElementVNode("li", null, _toDisplayString(_ctx.$t('proofreadingInstructions.postProofreadingUnlockStep2')), 1),
        _createElementVNode("li", null, _toDisplayString(_ctx.$t('proofreadingInstructions.postProofreadingUnlockStep3')), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('proofreadingInstructions.postProofreadingChangesTitle')), 1),
      _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t('proofreadingInstructions.postProofreadingChangesIntro')), 1),
      _createElementVNode("ol", null, [
        _createElementVNode("li", null, _toDisplayString(_ctx.$t('proofreadingInstructions.postProofreadingChangesStep1')), 1),
        _createElementVNode("li", null, _toDisplayString(_ctx.$t('proofreadingInstructions.postProofreadingChangesStep2')), 1),
        _createElementVNode("li", null, _toDisplayString(_ctx.$t('proofreadingInstructions.postProofreadingChangesStep3')), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('proofreadingInstructions.postProofreadingWarningTitle')), 1),
      _createTextVNode(" " + _toDisplayString(_ctx.$t('proofreadingInstructions.postProofreadingWarningText')), 1)
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('proofreadingInstructions.postProofreadingCommentsTitle')), 1),
      _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.$t('proofreadingInstructions.postProofreadingCommentsIntro')), 1),
      _createElementVNode("ol", null, [
        _createElementVNode("li", null, _toDisplayString(_ctx.$t('proofreadingInstructions.postProofreadingCommentsStep1')), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('proofreadingInstructions.postProofreadingUploadTitle')), 1),
      _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.$t('proofreadingInstructions.postProofreadingUploadText')), 1)
    ])
  ]))
}